import React from 'react';
import PropTypes from 'prop-types';
import TextButton from 'components/TextButton';
import { Text } from '@qga/roo-ui/components';

const NonRefundable = ({ handleOnClick, fontSize, hideWhenNonRefundable }) => {
  if (hideWhenNonRefundable) return null;

  const text = 'Non-refundable';

  return handleOnClick ? (
    <TextButton
      onClick={handleOnClick}
      fontSize={fontSize}
      fontWeight="bold"
      color="greys.steel"
      hoverColor="greys.steel"
      data-testid="cancellation-policy-message"
    >
      {text}
    </TextButton>
  ) : (
    <Text fontSize={fontSize} fontWeight="bold" color="greys.steel" data-testid="cancellation-policy-message">
      {text}
    </Text>
  );
};

NonRefundable.propTypes = {
  handleOnClick: PropTypes.func,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  hideWhenNonRefundable: PropTypes.bool.isRequired,
};

NonRefundable.defaultProps = {
  handleOnClick: null,
};

export default NonRefundable;
